import React from "react";
import Th from "./Th";

const Thead = ({ tableHeadData, checked = false, totalDataCount }) => {
  return (
    <>
      <thead>
        <tr className="text-white  text-xs leading-none border-b-2 border-magenta-100">
          {tableHeadData.map((item, i) => (
            <Th
              key={i}
              name={item.name}
              nameAlign={item.align}
              isSort={item.isSort}
              isFilter={item.isFilter}
              isSearchFilter={item.isSearchFilter}
              keywordSearch={item?.keywordSearch}
              searchData={item?.searchData}
              isOption={item?.isOption}
              onSearchFilter={item.onSearchFilter}
              filterDropdown={item?.filterData}
              onSort={item?.onSort}
              onFilter={item?.onFilter}
              filterData={item?.filterData}
              filterSearch={item?.filterSearch}
              type={item.type}
              isFilterSearch={item.isFilterSearch}
              checkboxChecked={checked}
              totalDataCount={totalDataCount}
              onCheckboxChange={() =>
                item.onCheckboxChange
                  ? item.onCheckboxChange(item.itemDetails || {})
                  : () => {}
              }
            />
          ))}
        </tr>
      </thead>
    </>
  );
};

export default Thead;
